import DropDown from "../../../shared/drop-down/dropDown";
import DateRangePicker from "../../../shared/dateRangePicker/dateRangePicker";
import ReactMap from "../../../shared/map/map";
import Slider from "../../../shared/slider/slider";

const TelematicsOnDemandSec = ({handleRequestDVR}) => {

    return (
        <div className="request-dvr-sec">
            <div className="flex gap-40 margin-b-40">
                <div className="width-200 round-corner-8 thin">
                    <DropDown
                        placeholder='Group' selected={''}
                        list={['Group 1', 'Group 2', 'Group 3']}
                        classes={'item-height-40'}/>
                </div>
                <div className="width-200 round-corner-8 thin">
                    <DropDown
                        placeholder='Vehicle Id' selected={''}
                        list={['KA 05 HJ 1890', 'KA 06 HJ 1360', 'KA 07 HJ 2890']}
                        classes={'item-height-40'}/>
                </div>
            </div>
            <div className='width-block-100 margin-b-30'>
                <Slider min={0}
                        max={100}
                        range={true}
                        value={[10, 40]}/>
            </div>
            <div className="flex hr-right">
                <div className="btn item-height-40 round-corner-8 font-14"
                     onClick={e => handleRequestDVR()}>
                    Request DVR Video
                </div>
            </div>
        </div>
    )

}

export default TelematicsOnDemandSec;
